import {
  faExclamationCircle,
  faPencil,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AgGridReact } from 'ag-grid-react'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { Card, CardBody } from 'reactstrap'
import { setAreYouSureModalData } from 'store/Recruitment/actions'
import { updateJobStageOrder } from 'store/Recruitment/actions'
import { setCurrentSetupSystemRows } from 'store/Recruitment/actions'
import { updateSetup } from 'store/Recruitment/actions'
import { getSystemSetup } from 'store/Recruitment/actions'
import { setEditingSystemSetup } from 'store/Recruitment/actions'

function CommonRowTable({ columns, setShowModal, reordable = false }) {
  const dispatch = useDispatch()

  const { currentSystemSetupRows } = useSelector((store) => store.recruitment)

  const rowDragColumn = {
    rowDrag: true, // Enables row dragging
    headerName: '', // Empty header
    width: 50, // Fixed width for the drag handle
    filter: false, // Disable filtering
    suppressMenu: true, // Disable column menu
    cellRenderer: () => (
      <div style={{ cursor: 'move' }}>
        <i className='fas fa-grip-lines'></i> {/* Drag handle icon */}
      </div>
    ),
  }

  const extraColumns = [
    {
      headerName: 'Action',
      field: 'action',
      cellRenderer: (params) => (
        <div className='d-flex align-items-center' style={{ gap: '1rem' }}>
          <FontAwesomeIcon
            size='lg'
            icon={faPencil}
            title='Edit'
            role='button'
            className='text-info'
            onClick={() => {
              dispatch(setEditingSystemSetup(true))
              dispatch(getSystemSetup(params.data.id ?? params.data.generalId))
              setShowModal(true)
            }}
          />
          <FontAwesomeIcon
            size='lg'
            icon={faTrash}
            title='Delete'
            role='button'
            className='text-danger'
            onClick={() => {
              dispatch(
                setAreYouSureModalData({
                  show: true,
                  customFn: () =>
                    dispatch(
                      updateSetup(undefined, {
                        id: params.data.id ?? params.data.generalId,
                        action: 'delete',
                      })
                    ),
                })
              )
            }}
          />
        </div>
      ),
      flex: 1,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
  ]

  useEffect(() => {
    dispatch(getSystemSetup())
  }, [dispatch])

  const gridRef = useRef()
  const [hasReordered, setHasReordered] = useState(false)

  const onRowDragEnd = (event) => {
    const api = gridRef.current.api
    if (!api) return

    const rowIndex = event.node.rowIndex
    const overNode = event.overNode

    if (!overNode || rowIndex === overNode.rowIndex) return

    setHasReordered(true)

    const newData = Array.from({ length: api.getDisplayedRowCount() }).map(
      (_, index) => {
        return api.getDisplayedRowAtIndex(index).data
      }
    )

    dispatch(setCurrentSetupSystemRows(newData))
    dispatch(updateJobStageOrder(currentSystemSetupRows))
  }

  const [finalColumns, setFinalColumns] = useState([
    ...columns,
    ...extraColumns,
  ])

  useEffect(() => {
    if (reordable) {
      setFinalColumns([rowDragColumn, ...columns, ...extraColumns])
    }
  }, [reordable])

  // useEffect(() => {
  //   return () => {
  //     if (reordable && hasReordered) {
  //       dispatch(updateJobStageOrder(currentSystemSetupRows))
  //     }
  //   }
  // }, [reordable, hasReordered])

  return (
    <>
      <div
        style={{ maxHeight: '600px', overflowY: 'auto' }}
        className='ag-theme-alpine w-100 scrollbar'
      >
        <AgGridReact
          ref={gridRef}
          columnDefs={finalColumns}
          rowData={currentSystemSetupRows}
          domLayout='autoHeight'
          animateRows={true}
          rowDragManaged={true}
          onRowDragEnd={onRowDragEnd}
          suppressMoveWhenRowDragging={true}
        />
      </div>
      {reordable && (
        <Card className='mt-3 bg-secondary mb-0'>
          <CardBody>
            Note : You can easily reorder rows using drag & drop.
            <FontAwesomeIcon
              icon={faExclamationCircle}
              className='text-warning ml-2 mr-1'
            />
            The first stage will be the default one.
          </CardBody>
        </Card>
      )}
    </>
  )
}

export default CommonRowTable
